import { render, staticRenderFns } from "./InfoDetailsView.vue?vue&type=template&id=52a08770&scoped=true&"
import script from "./InfoDetailsView.vue?vue&type=script&lang=js&"
export * from "./InfoDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./InfoDetailsView.vue?vue&type=style&index=0&id=52a08770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a08770",
  null
  
)

export default component.exports